<script>
    import Icon from 'svelte-awesome';
    import { ellipsisV, filter } from 'svelte-awesome/icons';
    import ItemTags from './ItemTags.svelte';
    export let index;
    export let item;
    export let filterAwaySource;
    export let handleManageItemAction;
    export let handleFilterAction;

    const trucatedDescription = (description) => {
        if (!description) return null;

        let truncatedDescription;

        if (description) {
            truncatedDescription = description.length < 300 ? description : description.slice(0, 300) + '...';
        }

		return truncatedDescription;
	}

    const getDate = date => {
        const timePart = '00:00:00 GMT';

        if (!date) return;

        if (date.endsWith(timePart)) {
            date = date.slice(0, -timePart.length);
        }

        return date;
    };

    const _filterAwaySource = (domain) => {
        filterAwaySource(domain);
    }

    function manageItem(e) {
        handleManageItemAction(item, index);
    }

    function filterItems(e) {
        handleFilterAction(item);
    }
</script>

<div style="margin-top: 30px" class="feed-item">
    <meta id="meta-data-{ index }" data-categories="{ item.categories }" data-category="{ item.category }" data-title="{ item.title }" data-link="{ item.link }" data-description="{ item.description }" data-pubdate="{ item.pubDate }">
    <span class="filter-item-icon item-icon" on:click|preventDefault|stopPropagation={filterItems}>
        <Icon data={filter} scale={1} />
    </span>
    <span class="manage-item-icon item-icon" on:click|preventDefault|stopPropagation={manageItem}>
        <Icon data={ellipsisV} scale={1} />
    </span>
    
    {#if item.title}
        <h3 class="feed-item-title">{item.title}</h3>
    {/if}
    
    <div style="margin-top: 20px">{ getDate(item.pubDate) }</div>

    {#if item.description}
        <div style="margin-top: 20px" class="item-description">{trucatedDescription(item.description, item.textBody)}</div>
    {/if}

    {#if item.textBody}
        <div style="margin-top: 20px" class="item-body">{item.textBody}</div>
    {/if}
    
    {#if item.link}
        <div style="margin-top: 20px">
            <a href="{ item.link }" target="_blank">{ item.link }</a>
            <br/>
            {#if filterAwaySource}
                <button class="hide-from-source-button" on:click="{() => _filterAwaySource(item.link.split('/')[2])}">hide items from this source</button>
            {/if}
        </div>
    {/if}
    
    {#if item.tags}
        <ItemTags itemTags={item.tags} />
    {/if}
</div>

<style>
    .feed-item {
        background-color:rgb(5,5,5);
        color: rgb(150,150,150);
        padding: 20px;

        /* These are technically the same, but use both */
        overflow-wrap: break-word;
        word-wrap: break-word;

        -ms-word-break: break-all;
        /* This is the dangerous one in WebKit, as it breaks things wherever */
        word-break: break-all;
        /* Instead use this non-standard one: */
        word-break: break-word;

        /* Adds a hyphen where the word breaks, if supported (No Blink) */
        -ms-hyphens: auto;
        -moz-hyphens: auto;
        -webkit-hyphens: auto;
        hyphens: auto;

        border: 2px solid rgba(150, 150, 150, 0.3);
        border-radius: 4px;
        cursor: pointer;
    }
    .feed-item-title {
        margin-top: 0px;
    }
    .hide-from-source-button {
        font-size: 12px;
        background: white;
        color: darkred;
        margin-top: 10px;
        border: none;
        padding-left: 0;
        cursor: pointer;
    }
    .filter-item-icon {
        top: 0px;
        right: 48px;
    }
    .manage-item-icon {
        top: 0px;
        right: 0px;
    }
    .item-icon {
        position: absolute;
        width: 48px;
        height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    @media only screen and (max-width: 767px) {
        h3 {
            font-size: 30px;
        }

        .item-description {
            font-size: 22px;
        }
        .item-body {
            font-size: 16px;
        }
        .feed-item-title {
            margin-top: 40px;
        }
    }
</style>